import { styled } from "@mui/material";

import { Box } from "@tsp/tsp-frontend-components/mui";

export const NotificationsBox = styled(Box)`
  position: fixed;
  z-index: 10000;
  left: 50%;
  transform: translateX(-50%);
`;

export const NotificationsItem = styled(Box)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;
